import Color from 'color';

export const isDark = (color: string): boolean => {
  return new Color(color).luminosity() < 0.25;
};
